export default "__VITE_ASSET__CSCspTqU__"